import axios, { AxiosInstance } from 'axios'
import Config from '@/config/config'
import { useLoadingStore } from '@/stores/loading'
import { useToastStore } from '@/stores/toast'
import { useLoggerStore } from '@/stores/logger'
import { processSentry } from '@/api/sentry'

const backendHost = import.meta.env.VUE_APP_BACKEND_HOST || 'localhost'
const backendPort = 3018

export const serverUrl = import.meta.env.PROD ? '' : 'http://localhost:3018'

export const baseURL = import.meta.env.PROD
  ? '/attendance/api'
  : `http://${backendHost}:${backendPort}/attendance/api`

export const clientBase = import.meta.env.PROD
  ? '/attendance'
  : `http://${backendHost}:${backendPort}`

export const socketPath = '/api/socket.io'

export const socketURL = import.meta.env.PROD ? '' : 'localhost:3001'

export const allowedOriginsULK = [
  'http://localhost:8086',
  'https://digital.etu.ru',
  'https://dev.digital.etu.ru'
]

export const http: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true
})

function isSilentUrl(url: string): boolean {
  return Config.urlsWithoutInterceptors.some(
    (u) => url === u || url.startsWith(u)
  )
}

http.interceptors.request.use(async (config) => {
  if (!isSilentUrl(config.url!)) {
    const loadingStore = useLoadingStore()
    loadingStore.enqueue()
  }
  return config
})

http.interceptors.response.use(
  async (response) => {
    if (!isSilentUrl(response?.config?.url ?? '')) {
      const loadingStore = useLoadingStore()
      loadingStore.dequeue()
    }
    return response
  },
  async (error) => {
    processSentry(error)
    if (!isSilentUrl(error?.config?.url ?? '')) {
      const loadingStore = useLoadingStore(),
        toastStore = useToastStore(),
        loggerStore = useLoggerStore()

      loadingStore.dequeue()

      let data: any
      if (error?.response?.data?.constructor === ArrayBuffer) {
        try {
          data = JSON.parse(new TextDecoder().decode(error?.response?.data))
        } catch {
          data = {}
        }
      } else {
        data = error?.response?.data
      }

      console.error(error?.response)
      toastStore.pushToast({
        error: true,
        title: 'Ошибка',
        message: data?.message || 'Ошибка сервера'
      })
      loggerStore.addLog({
        userId: 1,
        severity: 'error',
        message: 'ERROR',
        page: window.location.pathname,
        error: {
          type: 'axioserror' + (error?.response?.status ?? ''),
          message: data?.message ?? '',
          stack: data?.stack ?? ''
        },
        timestamp: Date.now()
      })
      loggerStore.sendLogs()
    }
    throw error
  }
)
